module.exports = __webpack_public_path__ + "sub-module/icons/fonts/icons.svg";